'use client';
import "./toggle-button.scss";

interface ToggleButtonProps {
    isActive: boolean;
    onClick: () => void;
}

const ToggleButton = ({ isActive, onClick }: ToggleButtonProps) => {
    return (
        <button
            type="button"
            data-testid="toggle-table"
            onClick={onClick}
            className="toggle-table"
        >
            {isActive ? (
                <>
                    <span className="toggle-table-text">Ver menos</span>
                    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.792994 5.79325L5.79299 0.79325C6.18399 0.40225 6.81599 0.40225 7.20699 0.79325L12.207 5.79325C12.598 6.18425 12.598 6.81625 12.207 7.20725C11.816 7.59825 11.184 7.59825 10.793 7.20725L6.49999 2.91425L2.20699 7.20725C1.81599 7.59825 1.18399 7.59825 0.792994 7.20725C0.597995 7.01225 0.499994 6.75625 0.499994 6.50025C0.499994 6.24425 0.597995 5.98825 0.792994 5.79325Z" fill="#E22446" />
                    </svg>
                </>
            ) : (
                <>
                    <span className="toggle-table-text">Ver mais</span>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M11.7072 2.20675L6.70725 7.20675C6.31625 7.59775 5.68425 7.59775 5.29325 7.20675L0.29325 2.20675C-0.09775 1.81575 -0.09775 1.18375 0.29325 0.79275C0.68425 0.40175 1.31625 0.40175 1.70725 0.79275L6.00025 5.08575L10.2933 0.79275C10.6842 0.40175 11.3162 0.40175 11.7072 0.79275C11.9022 0.98775 12.0002 1.24375 12.0002 1.49975C12.0002 1.75575 11.9022 2.01175 11.7072 2.20675Z" fill="#E22446" />
                    </svg>
                </>
            )}
        </button>
    )
}

export default ToggleButton;